export const CLASS_NAMES = {
  title: 'text-14-22-em text-neutral-800 mt-1',
  container: 'flex flex-col',
  header: 'flex flex-row mb-2',
};

export const FIELD_PROPS = {
  type: 'price',
  placeholder: '£0.00',
  icon: 'pound',
  iconVariant: 'dark',
  symbol: '',
};

export const PROPS = {
  householdAnnualIncome: {
    ...FIELD_PROPS,
    label: 'Household Annual Income',
    placeholder: 'Your household annual income',
  },
  monthlyCreditRepayments: {
    ...FIELD_PROPS,
    label: 'Monthly Credit Repayments (Total)',
    placeholder: 'The total of your credit repayments',
    name: 'credit_repayments',
  },
};

export const EMPLOYMENT_STATUS_FIELD_NAME =
  'credit.employment_details.employment_status';

export const GROSS_INCOME_NAME =
  'credit.employment_details.gross_annual_income.amount';

export const HOUSEHOLD_INCOME_NAME =
  'credit.employment_details.household_annual_income';

export const ADDITIONAL_EMPLOYMENT_NAME =
  'credit.additional_employment_details';
